import React from 'react'

import styles from '../../styles/login.css'
import CopyrightStatement from '../../components/CopyrightStatement'
import Loading from '../../components/Loading'
import KardiaProLogo from 'static/images/kardia_pro_logo.svg'

class SsoLogin extends React.Component {
  UNSAFE_componentWillMount() {
    const {
      match,
      location,
    } = this.props
    this.props.handleSsoQuery(match, location)
  }

  render() {
    return (
      <div data-page="sso-login" className={styles.ssoLogin}>
        <div className={styles.loginOuterCont}>
          <div className={styles.loginBox}>
            <section className={styles.header}>
              <div className={styles.logo}>
                <KardiaProLogo />
              </div>
            </section>
            <section className={styles.content}>
              <div className={styles.contentInner}>
                <div className={styles.preambleSso}>
                  <h4>Logging In</h4>
                  <Loading size="large" />
                </div>
              </div>
            </section>
            <section className={styles.footer}>
              <CopyrightStatement />
            </section>
          </div>
        </div>
      </div>
    )
  }
}


export default SsoLogin



// WEBPACK FOOTER //
// ./src/legacy/pages/SsoLogin/SsoLogin.jsx